module.exports = __webpack_public_path__ + "static/img/example6.7fac488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example6.jpg
// module id = 724
// module chunks = 0